
import Login from './pages/Login';
import RecuperarSenha from './pages/RecuperarSenha';
import Painel from './pages/Painel';
import Adm from './pages/Adm';
import Usuarios from './pages/Adm/Usuarios/index';
import Historico from './pages/Adm/Historico/index';
import HistoricoGet from './pages/Adm/HistoricoGet/index';
import UsuariosEditar from './pages/Adm/UsuariosEditar';
import FaturasAdm from './pages/Adm/Faturas/index';
import Online from './pages/Adm/Online/index';

import Fatura from './pages/Adm/Fatura';
import Resultado from './pages/Resultado';
import Dividas from './pages/Dividas';
import Placa from './pages/Placa';
import Perfil from './pages/Perfil';
import Cadastro from './pages/Cadastro';
import Vencido from './pages/Vencido';
import CadastreSe from './pages/CadastreSe';
import Contato from './pages/Contato';
import Faturas from './pages/Faturas';
import FaturasUsuario from './pages/Adm/FaturasUsuario';

import Sair from './pages/Sair';

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
      <Route path="/" exact element={<Login/>}/>
      <Route path="/Logue-se" exact element={<Login/>}/>
      <Route path="Faturas/:id" exact element={<Faturas/>}/>
      <Route path="Painel" exact element={<Painel/>}/>
      <Route path="Resultado/:doc" exact element={<Resultado/>}/>
      <Route path="Dividas/:doc" exact element={<Dividas/>}/>
      <Route path="Placa/:doc" exact element={<Placa/>}/>
      <Route path="/Perfil" exact element={<Perfil/>}/>
      <Route path="/Vencido" exact element={<Vencido/>}/>
      <Route path="/Cadastro" exact element={<Cadastro/>}/>
      <Route path="/Cadastre-se" exact element={<CadastreSe/>}/>
      <Route path="/Contato" exact element={<Contato/>}/>
      <Route path="/Adm" exact element={<Adm/>}/>
      <Route path="/Adm/Usuarios" exact element={<Usuarios/>}/>
      <Route path="/Adm/Usuarios/:id" exact element={<UsuariosEditar/>}/>      

      <Route path="/Adm/Historico/:id" exact element={<HistoricoGet/>}/>
      <Route path="/Adm/Historico" exact element={<Historico/>}/>
      <Route path="/Adm/Faturas" exact element={<FaturasAdm/>}/>
      <Route path="Adm/Faturas/usuario/:id" exact element={<FaturasUsuario/>}/>
      <Route path="/Adm/Faturas/:id" exact element={<Fatura/>}/>

      <Route path="/Adm/Online" exact element={<Online/>}/>
      <Route path="/Sair" exact element={<Sair/>}/>
      <Route path='/RecuperarSenha' exact element={<RecuperarSenha/>}/>
      </Routes>
    </Router>
  );
}

export default App;
